export function NotFound() {
 return (
  <div className="flex flex-col items-center justify-center h-screen text-white bg-neutral-900 select-none">
   <h1 className="text-5xl font-bold mb-4">404</h1>
   <p className="text-xl">Nie znaleziono strony.</p>
  </div>
 );
}
